<template>
    <div>

      <Header ref="children" ></Header>

      <!--左侧导航栏目视图-->
      <div class="left_body_content">
        <div class="left_nav_content">
          <div class="Student_info_content">
            <div class="Student_img_content" @click="local_addClildren">
              <img class="winm_icon" :src="children_info.avatar" alt="">  
                <div class="Student_Name">{{children_info.nickname}}<img class="simaaaa" src="../assets/Strokexxx.svg" alt=""></div>
            </div>  
            
            <div class="Student_Name1">{{$t('new_index.CurrentMonthLessons')}}</div>

            <div class="size_content_box">
              <div class="Completed">
                <div class="number_size">{{children_info.month_complete}}</div>
                <div class="number_content">{{$t('new_index.Completed')}}</div>
              </div>
              <div class="Completed">
                <div class="number_size">{{children_info.month_pending}}</div>
                <div class="number_content">{{$t('new_index.Scheduled')}}</div>
              </div>
              <div class="Scheduled">
                <div class="number_size">{{children_info.month_no_show}}</div>
                <div class="number_content">{{$t('new_index.NoShow')}}</div>
              </div>
            </div>
          </div> 


          <div class="nav_list_content">
            <ul>
              <router-link class="bj" to="/home/children/AttendClassNow">
                <li>
                  <img class="left_icon" src="../assets/nav1IconColor.svg" alt="">
                  <a href="javascript:;">{{$t('new_index.Attend_Class_Now')}}</a>
                  <img class="right_icon" src="../assets/1IconColor.svg" alt="">
                </li>
              </router-link>
              <router-link class="bj" to="/home/children/ClassEnrolled"> 
                <li>
                  <img class="left_icon" src="../assets/Path.svg" alt="">
                  
                  <a href="javascript:;">{{$t('new_index.Class_Enrolled')}}</a>
                  <img class="right_icon" src="../assets/1IconColor.svg" alt="">
                </li>
              </router-link>
              <router-link class="bj" to="/home/children/ViewCompletedLessons">
                <li>
                  <img class="left_icon" src="../assets/Stroke1kem.svg" alt="">
                  <a href="javascript:;">{{$t('new_index.View_Completed_Lessons')}}</a>
                  <img class="right_icon" src="../assets/1IconColor.svg" alt="">
                </li>
              </router-link> 
              <!-- <router-link class="bj" to="/home/children/ScheduleaClass">
                <li>
                  <img class="left_icon" src="../assets/aou.svg" alt="">
                  <a href="javascript:;">{{$t('new_index.Schedule_a_Class')}}</a>
                  <img class="right_icon" src="../assets/1IconColor.svg" alt="">
                </li>
              </router-link> -->
              <a class="bj" :href="jumpUrl" target="_blank">
                <li>
                  <img class="left_icon" src="../assets/Buy.svg" alt="">
                  <a>{{$t('new_index.Purchase_Lesson_Plan')}}</a>
                  <img class="right_icon" src="../assets/1IconColor.svg" alt="">
                </li>
              </a>
            </ul>
            <div class="shiqu_content">
              <img class="icon_shiqu" src="../assets/TimeCircle.svg" alt="">
              <span class="shiqumm">{{$t('index.timeZone')}}{{utils.globetime()}}</span>
            </div>
            <!-- <div></div> -->
          
          </div>
        </div>
        <div class="right_content">
            <router-view></router-view>
        </div> 
      </div>


      <el-dialog :visible.sync="dialogTableVisible" width="40%">
          <div class="sk1">{{$t('new_index.Dear_customer')}}: </div>
          <div class="sk1">{{$t('new_index.If')}}</div>
          <div class="sk1">{{$t('new_index.Please')}}</div>
          <div class="ik_keihssa sdimw"><img class="immkkll dh" src="../assets/Stroke1.svg" alt="">{{user_info.mobile}}</div>
          <div class="kiweixin sdimw"><img class="immkkll wxa" src="../assets/WeChat_lgo_icon1.svg" alt="">Wechat ID: {{user_info.wechat}}</div>
          <img class="ewm_img" :src="user_info.qr_code" alt="">
          <div style="text-align:center;margin:10px 0">请扫码添加顾问老师微信</div>
      </el-dialog>
      
    </div>
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from './views/header'
  import IndexFooter from './views/footer'
  import MyScheduled from './views/scheduled'
  import MyCourse from './views/course'
  import PastLesson from './views/lesson'

  //引入header组件
  import Header from './header/header'

  export default {
    inject:['reload'],
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
        height:100,
        data:[],
        children_info:[],
        dialogTableVisible:false,
        user_info:[],
        balanceData:{},
        jumpUrl:'',
      }
    },
    created () {
      this.jumpUrl = getStore(keys.lang)!='zh_CN'?window.location.origin+'/pricing/en/':window.location.origin+'/pricing/cn/'
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      console.log(222,this.$intercom)
      this.get_one_id();
      // 用户信息
      this.getUser()
      // 账户信息
      // this.getBalance()
      /**
       * 获取销售用户信息
       */
      this.Sales_information();
      // 孩子信息
      // this.getChild()
      // 搜索全部正在上和还没上的课
      // this.search()
      // if (this.$route.query.type == 1) {
      //   this.activeTitle = 'course'
      // } else {
      //   this.activeTitle = 'schedule'
      // }
    },
    methods: {
      /**
       * 打开弹窗
       */
      show_moodel(){
        this.dialogTableVisible = true;
      },
      /**
       * 获取默认的孩子ID
       */
      get_one_id:function(){
        let _this = this;
        this.$http.get('/api/students').then((res) => {
          if (res.data.code == 200) {
              console.log('孩子',res)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 点击头像跳转添加孩子页面
       */
      local_addClildren:function(){
        this.$router.push({path: '/home/children/addChildren'})
      },
      updateIntercom () {
        let time_zone = this.utils.getTimeZoneCity()
        this.$http.get('/api/intercomUser?time_zone='+ time_zone).then((res) => {
          setStore(keys.IntercomUser, res.data.data)
          this.$intercom.update({
            user_id: getStore(keys.IntercomUser).userId,
            phone: getStore(keys.IntercomUser).phone,
            email: getStore(keys.IntercomUser).email,
            name: getStore(keys.IntercomUser).name,
            'Kid Name': getStore(keys.IntercomUser).kid_name,
            'Timezone': time_zone,
            'Paid user': getStore(keys.IntercomUser).paid_user,
            'Credit balance': getStore(keys.IntercomUser).credit_balance
          })
        })
      },
      handleClick (tab, event) {
        console.log(tab, event)
        this.$router.push(this.$route.path)
        if (tab.name == 'course') {
          this.getCourse()
        } else if (tab.name == 'schedule') {
          this.getschedule()
        } else if (tab.name == 'lesson') {
          this.getLesson()
        }
      },
      toRecharge () {
        this.$router.push({path: '/recharge'})
      },
      //获取默认孩子信息
      getUser () {
        this.$http.get('/api/user/profile').then((res) => {
          if (res.data.code == 200) {
            this.data = res.data.data
            this.children_info = res.data.data.student_info
            setStore(keys.userProfile, res.data.data)
            this.$refs.children.up();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      // getChild () {
      //   this.$http.get('/api/students').then((res) => {
      //     if (res.data.code == 200) {
      //       console.log(res)
      //       this.childData = res.data.data
      //       store.setChildList(res.data.data)
      //     } else {
      //       this.$message({
      //         message: res.data.msg,
      //         type: 'warning'
      //       })
      //     }
      //   }).catch((error) => {
      //     console.log(error) // 请求失败返回的数据
      //   })
      // },
      search () {
        setStore(keys.searchFilter, this.searchStudentSn)
        // 我的时间表
        this.getschedule()
        this.getCourse()
        this.getLesson()
      },
      editChild () {
        this.$router.push({path: '/allChild'})
      },
      getschedule () {
        console.log('=============================this')
        // console.log(this)
        // console.log(navigator.language)
        // let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
        this.$http.get('/api/userSchedukeForStudent?type=1001&student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone() + '&pagesize=' + this.pagesize + '&page=' + this.pageNum).then((res) => {
          if (res.data.code == 200) {
            this.scheduleData = res.data.data
            this.now_status = res.data.now_status
            this.total = res.data.total
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      getCourse () {
        this.$http.post('/api/myCourse?student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone()).then((res) => {
          if (res.data.code == 200) {
            console.log(res)

            this.courseData = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      getLesson () {
        this.$http.get('/api/getCompletedLessonPC?student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone()).then((res) => {
          if (res.data.code == 200) {
            this.lessonData = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      toPayList () {
        this.$router.push({path: '/payHistory'})
      },
      RepeatSchedule (data) {
        if (data) {
          this.getschedule()
        }
      },
      handleCurrentChange (val) {
        this.pageNum = val
        this.getschedule()
      },
      /**
       * 获取销售信息
       */
      Sales_information:function(){
        // console.log('测试：',navigator.language)
        let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
        this.$http.get('/api/getUserInfo', {headers: {token:getStore(keys.token)}}).then((res) => {
          if (res.data.code == 200) {
            setStore(keys.user, res.data.data)
            this.user_info = res.data.data.salesperson_info
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
    },
    mounted () {
      let _this = this //很关键是要把父路由的vue实例赋给_this
      this.$root.$on("addDpm", function() {
          _this.show_moodel();
      });

      this.$intercom.boot({
        user_id: getStore(keys.IntercomUser).userId,
        phone: getStore(keys.IntercomUser).phone,
        email: getStore(keys.IntercomUser).email,
        name: getStore(keys.IntercomUser).name,
        'Kid Name': getStore(keys.IntercomUser).kid_name,
        'Timezone': getStore(keys.IntercomUser).Timezone,
        'Paid user': getStore(keys.IntercomUser).paid_user,
        'Credit balance': getStore(keys.IntercomUser).credit_balance
        // Phone_Number: getStore(keys.IntercomUser).phone
      })
      this.$intercom._init()
      this.$intercom.update({
        user_id: getStore(keys.IntercomUser).userId,
        phone: getStore(keys.IntercomUser).phone,
        email: getStore(keys.IntercomUser).email,
        name: getStore(keys.IntercomUser).name,
        'Kid Name': getStore(keys.IntercomUser).kid_name,
        'Timezone': getStore(keys.IntercomUser).Timezone,
        'Paid user': getStore(keys.IntercomUser).paid_user,
        'Credit balance': getStore(keys.IntercomUser).credit_balance
        // Phone_Number: getStore(keys.IntercomUser).phone
      })


      console.log(this.$intercom.visible)
    },
    watch: {
      '$intercom.visible': function (val) {
        if (val == true) {
          this.updateIntercom()
        }
      },
      email (email) {
        this.$intercom.update({email})
      }
    },
  }
</script>
<style lang="less" scoped>

.left_body_content{
    // width: 358px;
  // height: 900px;
  // border: 1px solid ;
  
  width: 100%;
  display: flex;
  min-width: 1200px;
  // position: fixed;
  // top: 84px;
  // bottom: 0;

  // background: #FCFCFF;
  // border: 1px solid red;
  .left_nav_content{
    width: 358px;
    // height: 900px;
    // border: 1px solid ;
    // position: fixed;
    // top: 84px;
    // bottom: 0;
    background: #FCFCFF;
    .Student_info_content{
      width: 281px;
      // height: 202px;
      border-bottom: 1px solid #EEF0FF;
      margin: 0 auto 0 auto;
      .Student_img_content{
        text-align: center;
        cursor: pointer;
      }
      .Student_Name{
        font-family: Sofia Pro;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        text-align: center;
        color: #000000;
        padding: 15px 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .Student_Name1{
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        text-align: center;
        color: #000000;
        padding: 15px 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .size_content_box{
        width: 201px;
        // height: 20px;
        border: 0px solid red;
        margin: 10px auto 0 auto;
        display: flex;
        margin-bottom: 50px;
        .Completed{
          width: 95px;
          border-right: 1px solid #CFCFCF;
          // height: 20px;
        }
        .Scheduled{
          width: 95px;
        }
      }
    }
    .nav_list_content{
      // width: 281px;
      width:358px;
      height: 270px;
      border: 0px solid red;
      margin: 0 auto 0 auto;
      li{
        width: 281px;
        height: 54px;
        border: 0px solid red;
        margin: 0 auto 0 auto;
        .left_icon{
          width: 22px;
          height: 22px;
          margin-top: 16px;
          float: left;
        }
        a{
          margin-left: 22px;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          align-items: center;
          color: #000000;
          float: left;
          margin-top: 17px;
        }
        .right_icon{
              float: right;
              margin-top: 21px;
        }
      }
    }
  }
  .right_content{
    // width: 400px;
    // height: 400px;
    // border: 1px solid red;
    // margin-left: 358px;
    // min-width: 1000px;
    // flex:1; */
    width: 100%;
    min-width: 902px;
  }
}
.number_size{
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 16px;
    text-align: center;
    color: #000000;
    margin-top: -5px;
}
.number_content{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    color: #A5A5A5;
    margin-top: 6px;
}
.bj{
  display: block;
}
.router-link-active{
  background: rgba(75, 105, 254, 0.08);
}
.winm_icon{
  width:60px;
  height:60px;
  border-radius: 100%;
  margin:20px auto 0;
}
.icon_shiqu{
  width:21px;
  height:21px;
  display: inline-block;
  float: left;
  margin-top: 18px;
}
.shiqumm{
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  /* identical to box height */
  text-decoration-line: underline;
  color: #000000;
  display: inline-block;
  float: left;
  margin: 20px 0 0 23px;
}
.shiqu_content{
  width: 281px;
  height: 54px;
  margin: 35px auto 0 auto;
  padding-top:35px;
  border-top:1px solid #EEF0FF;
}
.simaaaa{
  Width :15.68px;
  Height:17.44px;
  margin-left: 15px;
  cursor: pointer;
}
.ik_keihssa{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 15px;
  /* identical to box height, or 93% */
  color: #0B1D33;
  // text-align: center;
  margin-top:30px;
}
.kiweixin{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 15px;
  /* identical to box height, or 93% */
  color: #0B1D33;
  // text-align: center;
  margin-top:30px;
}
.sk1{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 20px !important;
  line-height: 20px;
  text-align: center;
  color: #000000;
  margin-bottom: 10px;
}
.sdimw{
  width: 326px !important;
  // border: 1px solid red;
  margin: 40px auto 0 auto !important;
}
.dh{
  position: relative;
  top: 6px;
  margin-right: 20px;
}
.wxa{
      position: relative;
    top: 8px;
    margin-right: 14px;
}
.ewm_img{
    width: 106px;
    height: 106px;
  margin:40px auto 0 auto;
  display: block;
  border:4px solid #4B69FE;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue